export const AUTH_ERROR_MESSAGES = {
  authenticationFailed: "We couldn't sign you in. Please try again.",
  logoutFailed: "We couldn't sign you out. Please try again.",
  getUserFailed:
    "We couldn't load your account information. Please refresh the page.",
  googleAuthFailed:
    "Google sign-in failed. Please try again or use email instead.",
  otpRequestFailed:
    "We couldn't send your verification code. Please try again.",
  otpVerifyFailed:
    "The verification code is incorrect or has expired. Please try again.",
  passwordlessRegistrationFailed:
    "We couldn't create your account. Please try again.",
} as const;
